import { motion } from 'framer-motion'
import { UserPlus, Wallet, Tag, HandCoins } from 'lucide-react'

const steps = [
  {
    icon: UserPlus,
    title: 'Cadastre-se',
    description:
      'Crie sua conta em poucos minutos e acesse seu painel exclusivo de influencer.',
  },
  {
    icon: Wallet,
    title: 'Ative seu recebimento',
    description:
      'Informe seus dados de pagamento para garantir que sua participação seja transferida de forma automática e segura.',
  },
  {
    icon: Tag,
    title: 'Crie seus cupons',
    description:
      'Defina o valor do desconto, a validade e personalize o código do seu cupom.',
  },
  {
    icon: HandCoins,
    title: 'Receba sua participação',
    description:
      'Cada compra feita com seus cupons gera uma participação direta para você, sem burocracia.',
  },
]

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
}

const itemVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0 },
}

const ComoFuncionaSection = () => {
  return (
    <section id="como-funciona" className="w-full py-20 md:py-28 bg-background">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        {/* Header */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold italic text-foreground">
            Como funciona?
          </h2>
        </motion.div>

        {/* Steps Grid */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          {steps.map((step, index) => (
            <motion.div
              key={step.title}
              variants={itemVariants}
              transition={{ duration: 0.5 }}
              className="flex flex-col items-center text-center p-6 bg-secondary/10 rounded-xl border border-secondary/20 hover:bg-secondary/15 hover:border-secondary/40 hover:shadow-elegant hover:-translate-y-1 transition-all duration-300"
            >
              {/* Step Number */}
              <div className="relative mb-6">
                <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
                  <step.icon className="w-7 h-7 text-primary" />
                </div>
                <span className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-accent text-accent-foreground text-sm font-semibold flex items-center justify-center">
                  {index + 1}
                </span>
              </div>

              {/* Content */}
              <h3 className="font-sans text-base font-semibold text-foreground mb-3">
                {step.title}
              </h3>
              <p className="font-body text-muted-foreground text-sm leading-relaxed">
                {step.description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  )
}

export default ComoFuncionaSection
